import { PaymentOffsetInterface } from "../PaymentOffsetInterface";
import { PaymentOffset } from "../PaymentOffset";
import Translator from "../../../../../Translation/Translator";

class FirstDayOfPeriod extends PaymentOffset implements PaymentOffsetInterface  {

  public static value: number = 0;

  public getName(): string {
    return Translator.trans("payment-offset-first-day-of-period");
  }

}

export { FirstDayOfPeriod }
